"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _ui = require("@alycecom/ui");

var _hooks = require("@alycecom/hooks");

var _PlaceholdersModal = _interopRequireDefault(require("../PlaceholdersModal/PlaceholdersModal"));

var _usePlaceholders2 = require("../../hooks/usePlaceholders/usePlaceholders");

var styles = {
  insertButton: {
    padding: 0
  }
};

var PlaceholdersButton = function PlaceholdersButton(_ref) {
  var button = _ref.button,
      inputRef = _ref.inputRef,
      onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      overwritePlaceholder = _ref.placeholders;
  var buttonRef = (0, _react.useRef)(null);

  var _useModalState = (0, _hooks.useModalState)(),
      isOpen = _useModalState.isOpen,
      handleClose = _useModalState.handleClose,
      handleToggle = _useModalState.handleToggle;

  var _usePlaceholders = (0, _usePlaceholders2.usePlaceholders)({
    fetch: isOpen && !(overwritePlaceholder && overwritePlaceholder.length)
  }),
      isFulfilled = _usePlaceholders.isFulfilled,
      fetchedPlaceholders = _usePlaceholders.placeholders;

  var placeholders = overwritePlaceholder || fetchedPlaceholders;

  var renderButton = button || function (buttonProps) {
    return /*#__PURE__*/_react.default.createElement(_ui.Button, (0, _extends2.default)({
      variant: "text",
      size: "small",
      sx: styles.insertButton,
      disabled: disabled
    }, buttonProps), "+ Insert custom data");
  };

  var handleButtonClick = (0, _react.useCallback)(function (event) {
    handleToggle();
    buttonRef.current = event.currentTarget;
  }, [handleToggle]);
  var handleInsert = (0, _react.useCallback)(function (placeholder) {
    if (inputRef.current) {
      handleClose();
      var _inputRef$current = inputRef.current,
          selectionStart = _inputRef$current.selectionStart,
          selectionEnd = _inputRef$current.selectionEnd;
      var firstPart = inputRef.current.value.substring(0, selectionStart !== null && selectionStart !== void 0 ? selectionStart : 0);
      var lastPart = inputRef.current.value.slice(selectionEnd !== null && selectionEnd !== void 0 ? selectionEnd : 0, inputRef.current.value.length);
      var leadingSpace = firstPart.endsWith(' ') || firstPart === '' ? '' : ' ';
      var trailingSpace = lastPart.startsWith(' ') || lastPart === '' ? '' : ' ';
      var addedPart = "".concat(leadingSpace).concat(placeholder.value).concat(trailingSpace);
      onChange("".concat(firstPart).concat(addedPart).concat(lastPart));
      setTimeout(function (input) {
        return function () {
          Object.assign(input, {
            selectionStart: (selectionStart !== null && selectionStart !== void 0 ? selectionStart : 0) + addedPart.length,
            selectionEnd: (selectionStart !== null && selectionStart !== void 0 ? selectionStart : 0) + addedPart.length
          });
          input.focus();
        };
      }(inputRef.current), 0);
    }
  }, [inputRef, handleClose, onChange]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderButton({
    onClick: handleButtonClick
  }), /*#__PURE__*/_react.default.createElement(_PlaceholdersModal.default, {
    open: isOpen && !!buttonRef.current && !!inputRef.current,
    anchorEl: buttonRef.current,
    onInsert: handleInsert,
    onClose: handleClose,
    placeholders: placeholders,
    loading: !isFulfilled && !overwritePlaceholder
  }));
};

var _default = PlaceholdersButton;
exports.default = _default;